goog.provide('el8.util.amplitude.helpers');

el8.util.amplitude.initialized = false;

el8.util.amplitude.initialize = function() {
  if (el8.util.amplitude.initialized) return;

  var amp = amplitude.getInstance();

  amp.setUserId(el8Globals.USER_ID);

  var userType = el8Globals.USER_STAFF_TYPE;
  // Translate to terms more commonly used
  if (userType === 'Physician') {
    userType = 'Provider';
  } else if (userType === 'OfficeStaff') {
    userType = 'Staff';
  }

  var appType = el8Globals.EMR_TYPE;
  if (appType === 'passport') {
    // use the new rebranded name
    appType = 'connect';
  }
  amp.setUserProperties({
    'user type': userType,
    'app type': appType,
    'practice state': el8Globals.PRACTICE_STATE,
    'full name': el8.data.currUser.getFullName(),
    'email': el8.data.currUser.getEmail(),
    'practice name': el8.data.currPractice.getName(),
    'features': _.keys(el8Globals.FEATURES).filter(function(k) { return el8Globals.FEATURES[k] })
  });

  amp.setGroup('practice', el8Globals.PRACTICE_ID);
  if (el8Globals.ENTERPRISE_ID) {
    amp.setGroup('enterprise', el8Globals.ENTERPRISE_ID);
  }

  el8.util.amplitude.initialized = true;
};

/**
 * Log an event in Amplitude.
 *
 * @param {string} eventType : what the event type should be in amplitude
 * @param {object} ampData : the event properties we want to pass for that event
 */
el8.util.amplitude.logEvent = function(eventType, data) {
  var ampData = data || {};
  try {
    if (!el8.util.amplitude.initialized) {
      el8.util.amplitude.initialize();
    }
    var instance = amplitude.getInstance();
    var amplitudeEventId = instance.logEvent(eventType, ampData);

    // Forwarding Amplitude Events to DataDog RUM gives us a way
    // to beef up the Event Timeline in Session Replays (as we use
    // DataDog RUM for replays at the moment).
    window.DD_RUM && window.DD_RUM.addAction("Amplitude:" + eventType, {
      type: "amplitude",
      eventData: data,
      amplitudeEventId: amplitudeEventId,
      amplitudeSessionId: instance.getSessionId(),
    });
  } catch(err) {
    // not going to do anything if it fails
  }
};

/**
 * Logs an event in Amplitude with a custom timestamp. Can be useful
 * if the event occurred at some time other than when the call was
 * made to log the event.
 *
 * @param {string} eventType : what the event type should be in amplitude
 * @param {object} ampData : the event properties we want to pass for that event
 * @param {Date} timestamp A Date object representing a custom timestamp for this event
 */
el8.util.amplitude.logEventWithTimestamp = function(eventType, data, timestamp) {
  var ampData = data || {};
  try {
    if (!el8.util.amplitude.initialized) {
      el8.util.amplitude.initialize();
    }
    var instance = amplitude.getInstance();
    var amplitudeEventId = instance.logEventWithTimestamp(eventType, ampData, Number(timestamp));

    // Forwarding Amplitude Events to DataDog RUM gives us a way
    // to beef up the Event Timeline in Session Replays (as we use
    // DataDog RUM for replays at the moment).
    window.DD_RUM && window.DD_RUM.addAction("Amplitude:" + eventType, {
      type: "amplitude",
      eventData: data,
      amplitudeEventId: amplitudeEventId,
      amplitudeSessionId: instance.getSessionId(),
    });
  } catch(err) {
    // not going to do anything if it fails
  }
};

el8.util.amplitude.setUserProperty = function(propertyName, value) {
  try {
    if (!el8.util.amplitude.initialized) {
      el8.util.amplitude.initialize();
    }
    var identify = new amplitude.Identify().set(propertyName, value);
    amplitude.getInstance().identify(identify);
  } catch (err) {
    // not going to do anything if it fails
  }
}

el8.util.amplitude.addUserProperty = function(propertyName, amount) {
  try {
    if (!el8.util.amplitude.initialized) {
      el8.util.amplitude.initialize();
    }
    var identify = new amplitude.Identify().add(propertyName, amount);
    amplitude.getInstance().identify(identify);
  } catch (err) {
    // not going to do anything if it fails
  }
}
